// 매장대표 개인 정기 할 일 API (스크린챗 #581).
// 자동 갱신은 없다. 최초 화면 조회와 완료 직후 재조회만 서버를 다시 부르고,
// 등록·수정·삭제는 쓰기 응답에 포함된 새 목록을 그대로 캐시에 넣는다.

import { authJson } from "./_client";
import type {
  RecurringTaskInput,
  RecurringTaskListResponse,
} from "../../shared/recurring-tasks";

const API = `${import.meta.env.VITE_API_BASE_URL ?? ""}/api/v2/recurring-tasks`;

export const recurringTasksQk = ["recurring-tasks"] as const;

export function fetchRecurringTasks(): Promise<RecurringTaskListResponse> {
  return authJson<RecurringTaskListResponse>(API);
}

export function createRecurringTask(
  input: RecurringTaskInput,
): Promise<RecurringTaskListResponse> {
  return authJson<RecurringTaskListResponse>(API, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateRecurringTask(
  id: number,
  input: RecurringTaskInput,
): Promise<RecurringTaskListResponse> {
  return authJson<RecurringTaskListResponse>(`${API}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteRecurringTask(id: number): Promise<RecurringTaskListResponse> {
  return authJson<RecurringTaskListResponse>(`${API}/${id}`, { method: "DELETE" });
}

export function completeRecurringTask(id: number): Promise<{ ok: true }> {
  return authJson<{ ok: true }>(`${API}/${id}/complete`, { method: "POST" });
}
